import { render, staticRenderFns } from "./PaqueteBusquedaIndividual.vue?vue&type=template&id=c688928a&scoped=true"
import script from "./PaqueteBusquedaIndividual.vue?vue&type=script&lang=js"
export * from "./PaqueteBusquedaIndividual.vue?vue&type=script&lang=js"
import style0 from "./PaqueteBusquedaIndividual.vue?vue&type=style&index=0&id=c688928a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c688928a",
  null
  
)

export default component.exports